module.exports = __webpack_public_path__ + "static/media/haute15F.57c6615c.jpg";